import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { getTransactionListings, ITransactionListing } from 'src/common/helpers/transaction-helper';
import { CartStatus } from 'src/items-list/business-logic/service/enumerations/cart-status';
import { showResumeTransaction } from 'src/resume-transaction/recall-transaction';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { showSavedTransactionsScreen } from '../components/saved-transaction/saved-transactions-screen';
import { recallTransaction } from './recall-transaction';

export const pushRecallTransactionScreen = (): void => {
  const onClose = (): void => restorePage();

  const onList = async (): Promise<void> => {
    await withSpinner(async () => {
      return getTransactionListings({ status: CartStatus.Suspended })
        .then(handleSavedTransactions)
        .catch(popupMessage);
    });
  };

  const onScan = async (scanData: string): Promise<void> => {
    await recallTransaction(scanData, true)
      .then(onClose)
      .catch(popupMessage);
  };

  const onSubmit = async (barcode: string): Promise<void> => {
    await recallTransaction(barcode, true)
      .then(onClose)
      .catch(popupMessage);
  };

  showResumeTransaction({ onClose, onList, onSubmit, onScan });
};

const handleSavedTransactions = (savedTransactions: ITransactionListing[]) => {
  const onCancel = (): void => restorePage();
  const onSubmit = async (transactionDetail?: ITransactionListing): Promise<void> => {
    const transactionId = transactionDetail?.transactionId || '';
    const cartReference = transactionDetail?.cartReference;
    const touchpointId = transactionDetail?.touchPointId;
    return recallTransaction(transactionId, false, touchpointId, cartReference)
      .then(onCancel)
      .catch(err => {
        popupMessage(err);
      });
  };
  showSavedTransactionsScreen({ onCancel, onSubmit, savedTransactions });
};
